import { combineReducers } from "redux";
import studentReducer from "./studentReducer";
import adminReducer from "./adminReducer";
import userReducer from "./userReducer";

const rootReducer = combineReducers({
  student: studentReducer,
  admin: adminReducer,
  user: userReducer,
});

export default rootReducer;
